const forgotPasswordEN = {
	title: "Forgot your password?",
	subtitle: "No worries, it happens to everyone. Enter your email and we’ll send you a reset link.",
	email: "Email address",
	hint: "Use the address you signed up with. The link expires in 15 minutes.",
	backToSignIn: "Back to sign in",
	send: "Send reset link",
	sending: "Sending...",
	success: "You're all set! Check your inbox — we sent you a link to reset your password.",
	toast: {
		error: "We couldn't send the email. Please try again in a moment.",
	},
};

export default forgotPasswordEN;
